import { useLayoutEffect, useState } from 'react'
import { useLocation } from 'react-router'

import LanguageIcon from '@mui/icons-material/Language'

import Box from '@mui/material/Box'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Fade from '@mui/material/Fade'
import GlobalStyles from '@mui/material/GlobalStyles'
import Paper from '@mui/material/Paper'

import useFormatMessage from '@hooks/useFormatMessage'

import styles, { googleChromeStyles } from './GoogleTranslate.styles'

const googleTranslateElementInit = () => {
  new window.google.translate.TranslateElement(
    {
      pageLanguage: 'en',
      includedLanguages: 'ar,en,es,fr',
      autoDisplay: false,
    },
    'google_translate_element'
  )
}

/**
 * Google Widget for translating the entire page content.
 */
export default function GoogleTranslate() {
  const [open, setOpen] = useState(false)
  const formatMessage = useFormatMessage()
  const location = useLocation()

  const isMessagesPage = location.pathname.startsWith('/app/messages')

  useLayoutEffect(() => {
    // Prevent the Google Translate script from being loaded multiple times
    const scriptElement = document.getElementById('googleTranslateScript')
    if (!scriptElement) {
      const addScript = document.createElement('script')
      addScript.setAttribute('id', 'googleTranslateScript')
      addScript.setAttribute('src', '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit')
      document.body.appendChild(addScript)
      window.googleTranslateElementInit = googleTranslateElementInit
    }
  }, [])

  const handleClickAway = () => {
    if (open) setOpen(false)
  }

  return (
    <>
      <GlobalStyles styles={googleChromeStyles} />
      <ClickAwayListener onClickAway={handleClickAway}>
        <Paper elevation={0} sx={[styles.container, open && styles.open, isMessagesPage && { display: 'none' }]}>
          <Box id="google_translate_element" sx={styles.widget} />
          <Fade in={!open}>
            <Box
              onClick={() => setOpen((o) => !o)}
              sx={styles.tongue}
              role="button"
              aria-label={formatMessage('profile.language.placeholder')}
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  setOpen((o) => !o)
                }
              }}
            >
              <LanguageIcon fontSize="small" aria-hidden="true" />
            </Box>
          </Fade>
        </Paper>
      </ClickAwayListener>
    </>
  )
}
